import Skeleton from 'react-loading-skeleton';
import TransactionListLoader from '~myAccount/pages/Wallet/TransactionListLoader';
export default function WalletLoader() {
  return (
    <div className="flex flex-col gap-3 p-2x md:p-4x">
      <div className="flex justify-between items-start">
        <div className="flex gap-2 items-center">
          <Skeleton width={40} height={40} borderRadius={12} />
          <div className="flex flex-col gap-1x">
            <Skeleton width={120} height={14} />
            <Skeleton width={90} height={18} />
          </div>
        </div>
      </div>

      <div className="flex justify-between">
        <div className="flex gap-2x">
          <Skeleton width={48} height={32} borderRadius={12} />
          <Skeleton width={64} height={32} borderRadius={12} />
          <Skeleton width={64} height={32} borderRadius={12} />
        </div>
        <Skeleton width={120} height={40} borderRadius={12} />
      </div>

      <TransactionListLoader />
    </div>
  );
}
